import { useOieRoutes } from "./routes";
import { GetDefaultIndex } from "../../components";
import { useGetOieCommonInfoQuery } from "../../features/api/oieApi";

export { useOieRoutes };

export default GetDefaultIndex({
  title: "درآمدهای عملیاتی",
  query: useGetOieCommonInfoQuery,
});
